module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3724156c798fb9f1230c9bd1c877f1fd.png";